import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Search, FolderKanban, UserCheck, User } from "lucide-react";
import { api } from "@/lib/api";

const ICON = { project: FolderKanban, customer: UserCheck, user: User };
const PATH = { project: (id) => `/projects/${id}`, customer: (id) => `/customers`, user: () => `/settings` };

export function GlobalSearch({ open, onClose, onNavigate }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (!q || q.length < 2) { setResults([]); return; }
    const t = setTimeout(() => {
      api.get("/search", { params: { q } }).then((r) => setResults(r.data.results)).catch(() => {});
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  useEffect(() => { if (!open) { setQ(""); setResults([]); } }, [open]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="p-0 gap-0 max-w-xl top-[20%] translate-y-0">
        <DialogTitle className="sr-only">Global search</DialogTitle>
        <div className="flex items-center gap-2 px-4 py-3 border-b border-[#E3DAC8]">
          <Search size={18} className="text-neutral-400" />
          <input
            autoFocus
            data-testid="global-search-field"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search projects, customers, people…"
            className="flex-1 outline-none text-sm bg-transparent"
          />
        </div>
        <div className="max-h-80 overflow-y-auto p-2">
          {results.length === 0 && (
            <div className="text-sm text-neutral-400 px-3 py-6 text-center">
              {q.length < 2 ? "Type at least 2 characters" : "No results"}
            </div>
          )}
          {results.map((r) => {
            const Icon = ICON[r.type] || Search;
            return (
              <button
                key={`${r.type}-${r.id}`}
                data-testid={`search-result-${r.type}`}
                onClick={() => onNavigate(PATH[r.type](r.id))}
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md hover:bg-[#EEE9DE] text-left transition-colors"
              >
                <Icon size={17} className="text-[#F56B1F]" />
                <span className="flex-1">
                  <span className="block text-sm text-neutral-900">{r.label}</span>
                  <span className="block text-xs text-neutral-500 mono">{r.sub}</span>
                </span>
                <span className="text-[10px] uppercase tracking-wider text-neutral-400">{r.type}</span>
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
